import { __decorate } from "tslib";
import { AsnType, AsnTypeTypes } from "@peculiar/asn1-schema";
import { Name } from "@peculiar/asn1-x509";
import { DomainName } from "./domain_name";
import { id_ntQWAC } from "./oids";
export const id_DomainNameBeneficiary = `${id_ntQWAC}.1`;
let DomainNameBeneficiary = class DomainNameBeneficiary extends DomainName {
    constructor(items) {
        super(items);
        Object.setPrototypeOf(this, Name.prototype);
    }
};
DomainNameBeneficiary = __decorate([
    AsnType({ type: AsnTypeTypes.Sequence })
], DomainNameBeneficiary);
export { DomainNameBeneficiary };
